define("powergen/components/x-social-links",
  [],
  function() {
    "use strict";
    var XSocialLinksComponent;

    XSocialLinksComponent = Ember.Component.extend({
      tagName: 'div',
      classNames: ['social'],
      actions: {
        share: function(site) {
          var link;
          link = site === "facebook" ? this.get('facebookLink') : this.get('twitterLink');
          link += this.get('shareText');
          _gaq.push(['Social', 'share', site]);
          return window.open(link, '_blank');
        }
      },
      shareText: "Try the new Total System Optimizer and test your system design skills. See how you match up against the experts!",
      altShareText: (function() {
        return "Think you can beat my score of " + this.get('score') + " with the Colfax Fluid Handling Total System Optimizer? Give it a try!";
      }).property(),
      score: 0,
      facebookLink: "https://www.facebook.com/sharer/sharer.php?s=100&p[url]=http%3A%2F%2Fwww.colfaxcorp.com%2Fpower-generation&p[title]=Total%20System%20Optimizer&p[images][0]=http://www.colfaxcorp.com/images/tout/total_system.png&p[summary]=",
      twitterLink: "https://twitter.com/share?url=http%3A%2F%2Fwww.colfaxcorp.com%2Fpower-generation&text="
    });


    return XSocialLinksComponent;
  });